/*
 * @Author: JamesWong
 * @Description: 物流配置中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: James Wong
 * @Last Modified time: 2019-04-19 17:42:21
 */
export default {
  receive: '收货',
  deliver: '发货',
  inventory: '盘点',
  createInvoice: '自建单据',
  dispose: '配置',
  modelDisposition: '模块配置',
  modelName: '模块名称',
  enterModelnameTips: '请填写模块名称',
  modelId: '模块ID',
  enterModelIdTips: '请填写模块ID',
  noticeName: '通知单名称',
  noticeName1: '盘点单名称',
  enterNoticenameTips: '请填写通知单名称',
  enterNoticenameTips1: '请填写盘点单名称',
  noticeId: '通知单ID',
  noticeId1: '盘点单ID',
  enterNoticeIdTips: '请填写通知单ID',
  enterNoticeIdTips1: '请填写盘点单ID',
  confirm: '确定',
  cancel: '取消',
  noticeModelName: '通知单模块名称',
  noticeModelId: '通知单模块ID',
  operate: '操作',
  edit: '编辑',
  delete: '删除',
  stockCheckPlan: '盘点计划',
  stockCheckAnalysis: '盘点分析',
  stockChecklist: '盘点单',
  modelAddSuccess: '模块新增成功！',
  modelUpdateSuccess: '模块更新成功！',
  deliveryNotice: '发货通知单',
  replenishment: '补货'
}


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/inout.js